import baseOptions from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';
import abbreviateNumber from '../../../utils/abbreviateNumber';

const horizontalBar = ({
  title,
  showLegend,
  openMenu,
  groupField,
  fieldType,
  chartDef,
  showDataLabels,
  fontSize,
  formatMetric,
  dateScope,
  autoInterval,
}) => ({
  ...baseOptions(formatMetric),
  chart: {
    ...baseOptions(formatMetric).chart,
    styledMode: false,
    type: 'bar',
    marginTop: 24,
  },
  title: {
    ...baseOptions(formatMetric).title,
    text: title,
  },
  yAxis: [
    {
      ...baseOptions(formatMetric).yAxis[0],
      title: {
        enabled: false,
      },
    },
  ],
  plotOptions: {
    bar: {
      borderRadius: '5%',
      borderWidth: 0,
      dataLabels: {
        enabled: !!showDataLabels,
        color: 'var(--color-text-primary)',
        formatter: function () {
          const { y, series } = this;
          const { step, metricId } = series.userOptions;
          const index = this.point.index;
          const isHidden = !!step && index % step !== 0;
          const abbreviated = abbreviateNumber(y);
          const formattedY = formatMetric({
            metricId,
            value: abbreviated ? abbreviated.abbreviated : y,
          });
          if (isHidden) {
            return '';
          }
          return `<b>${formattedY}</b>`;
        },
        style: {
          fontSize,
          textOutline: 'none',
        },
      },
      point: {
        events: {
          click: function (e) {
            const selectedIndex = e.point.x;
            const terms = e.point.series.data;
            const series = e.point.series.chart.series;
            if (openMenu) {
              const { metricIds, queryOverrides } = this.series.userOptions;
              const selectedTerm = terms.find((t, index) => {
                return index === selectedIndex;
              });

              openMenu(
                metricIds,
                buildDrillDown(
                  groupField,
                  fieldType,
                  selectedTerm.category,
                  chartDef,
                  dateScope,
                  autoInterval,
                ),
                queryOverrides,
              );
            } else {
              // @ts-ignore
              const { onDrillDown } = this.series.userOptions;
              if (!onDrillDown) {
                alert('Coming soon...');
                return;
              }
              if (series.length > 1) {
                // multi series
                series[0].data.forEach((d, dataIndex) => {
                  if (dataIndex === selectedIndex) {
                    onDrillDown(d.name || d.category, e.ctrlKey || e.metaKey);
                  }
                });
              } else {
                // single series
                terms.forEach((t, index) => {
                  if (index === selectedIndex) {
                    onDrillDown(t.name || t.category, e.ctrlKey || e.metaKey);
                  }
                });
              }
            }
          },
        },
      },
    },
  },
  legend: {
    ...baseOptions(formatMetric).legend,
    enabled: showLegend,
  },
});

export default horizontalBar;
